import { styled } from '@project44/manifest-ds';

export const CurrentPosition = styled('div', {
  display: 'flex',
  width: '28px',
  height: '28px',
  borderRadius: '$full',
  color: 'white',
  background: '$brand-gradient',
  border: '2px solid $brand-gradient',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  '&:before': {
    content: '" "',
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: 'translate(50%, -50%)',
    width: '44px',
    height: '44px',
    borderRadius: '$full',
    opacity: 0.3,
    background: '$brand-gradient',
    zIndex: -1,
  },
});

export const MarkerWrapper = styled('div', {
  display: 'flex',
  width: '28px',
  height: '28px',
  borderRadius: '28px',
  color: '$text-primary',
  border: '2px solid $palette-grey-300',
  background: '$background-primary',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  variants: {
    complete: {
      true: {
        background: '$palette-indigo-500',
        border: '2px solid $palette-indigo-500',
        color: '$background-primary',
      },
    },
  },
});

export const MarkerLabel = styled('div', {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: '50%',
  left: '34px',
  transform: 'translateY(-50%)',
  height: '24px',
  whiteSpace: 'nowrap',
  background: '$palette-grey-700',
  color: '$text-contrast',
  borderRadius: '$small',
  padding: '0 $small',
});
